import React from "react";
import PropTypes from "prop-types";
import { Column, Field, Control, Label, Input, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  BooleanInput,
  DateInput,
  SystemCodeSelect
} from "../../../../components/inputs";

const Details = ({ inputs, editing, onChange }) => (
  <React.Fragment>
    <Column.Group>
      <Column>
        <Field kind="group">
          <Control>
            <Label>Tariff Code</Label>
            <Input
              autocomplete="new"
              name="TariffCode"
              readOnly={!editing}
              type="text"
              value={inputs.TariffCode}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Description</Label>
            <Input
              disabled={!editing}
              name="Description"
              type="text"
              value={inputs?.Description}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>Begin Date</Label>
            <DateInput
              name="BeginDate"
              readOnly={!editing}
              value={inputs.BeginDate}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <Label>End Date</Label>
            <DateInput
              name="EndDate"
              readOnly={!editing}
              value={inputs.EndDate}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Label>Fuel Surcharge Rate</Label>
          <Control>
            <Field kind="addons">
              <Control expanded>
                <Input
                  name="FuelSurchargeRate"
                  readOnly={!editing}
                  value={inputs.FuelSurchargeRate}
                  onChange={onChange}
                />
              </Control>
              <Control>
                <Button static>
                  <Icon>
                    <FontAwesomeIcon icon="percent" />
                  </Icon>
                </Button>
              </Control>
            </Field>
          </Control>
        </Field>
      </Column>
      <Column>
        <Field kind="group">
          <Control expanded>
            <SystemCodeSelect
              icon="globe"
              label="Tariff Type"
              lookup={{ Category: "Tariff", Code: "TariffType" }}
              name="TariffTypeRecIdRef"
              readOnly={!editing}
              value={inputs?.TariffTypeRecIdRef}
              valueKey="RecId"
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              readOnly={!editing}
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <Label>Min. Load</Label>
            <Input
              autocomplete="new"
              name="MinLoad"
              readOnly={!editing}
              type="number"
              value={inputs.MinLoad}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <Label>Max. Load</Label>
            <Input
              autocomplete="new"
              name="MaxLoad"
              readOnly={!editing}
              type="number"
              value={inputs.MaxLoad}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <Label>Min. Charge</Label>
            <Input
              autocomplete="new"
              name="MinCharge"
              readOnly={!editing}
              type="text"
              value={inputs.MinCharge}
              onChange={onChange}
            />
          </Control>
        </Field>
      </Column>
    </Column.Group>
  </React.Fragment>
);

Details.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool
};
Details.defaultProps = {
  inputs: {}
};
export default Details;
